import Logo from '@library/assets/images/pp-logos/Logo.svg';

export const BackOfficeLogo = () => {
  return <img className="h-10 w-auto p-2" src={Logo} alt="logo" />;
};
